module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_2-de987c716292ed95e3583447abd2c0fd.webp";